const actionTypeIdentifier = '879PCE9Z-MN32-H2G3-K09J-P9JK721HGK8S'; //this is a newid

export const setDefaultSubLineItem = `SET-DEFAULT-SUB-LINE-ITEMS-${actionTypeIdentifier}`;
export const getAllSubLine = `GET-ALL-EXTERNAL-SUB-LINE-ITEMS-${actionTypeIdentifier}`;
export const setAllSubLineError = `SET-ALL-EXTERNAL-SUB-LINE-ERROR-${actionTypeIdentifier}`;
export const setAllSubLineItemPageSize =  `SET-ALL-SUBLINE-ITEM-PAGESIZE-${actionTypeIdentifier}`;
export const sortAllSubLineItems = `SORT-ALL-EXTERNAL-SUB-LINE-ITEMS-${actionTypeIdentifier}`;
export const setAllSubLineItemColSearchStr = `SET-ALL-EXTERNAL-SUBLINE-ITEM-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const getSubLineGrossSummary = `GET-SUBLINE-GROSS-SUMMARY-${actionTypeIdentifier}`;